import { render } from "./MyWorks.vue?vue&type=template&id=42bd0f74&scoped=true"
import script from "./MyWorks.vue?vue&type=script&lang=js"
export * from "./MyWorks.vue?vue&type=script&lang=js"

import "./MyWorks.vue?vue&type=style&index=0&id=42bd0f74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bd0f74"]])

export default __exports__